// PA Account Settings (nurse) — PROD-1817.
//
// Thin wrapper over the ported dev-scrips-pm-react `StaffEditPage`. PA's own
// page + 5 staff tab bodies are superseded by the port and removed.
//
// Same scope argument as the doctor page: `StaffEditPage` ships PM's own
// `accountMode` ("The logged-in staff member edits their OWN record. Set by
// AccountSettingsRoute, never by the admin list routes"), and in that mode the
// id comes from `idOverride` rather than a `:staffSetupId` route param.
//
// Mirrors Flutter `base_screen.dart`: StaffBaseWidget(isFromAccountSettings: true).
import { StaffEditPage } from './staff-edit/staff-edit-page';

export interface NurseAccountSettingsPageProps {
  /** The logged-in nurse's own setup-record GUID (`user.id`). */
  staffSetupId: string;
}

export function NurseAccountSettingsPage({ staffSetupId }: NurseAccountSettingsPageProps) {
  return <StaffEditPage mode="edit" accountMode idOverride={staffSetupId} />;
}
